export default __webpack_public_path__ + "static/media/logo-icon.e565612f.svg";